import axios from "axios";
import { UserStatistics } from "../models/UserStatistics.model";

const SERVER = process.env.REACT_APP_SERVER_BASE;

export const getUserStatistics = async (
  userId: string
): Promise<UserStatistics> => {
  const response = await axios.get<UserStatistics>(
    `${SERVER}/userStatistics/${userId}`
  );

  if (response.status !== 200) throw new Error("User not found");
  else return response.data;
};

export const getUserStatisticsWithDate = async (
  userId: string,
  startDate: string
): Promise<UserStatistics> => {
  const response = await axios.get<UserStatistics>(
    `${SERVER}/userStatistics/${userId}/${startDate}`
  );

  if (response.status !== 200) throw new Error("User not found");
  else return response.data;
};
